var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFan4High(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0C28.5523 0 29 0.447715 29 1L29 32C29 32.5523 28.5523 33 28 33C27.4477 33 27 32.5523 27 32L27 1C27 0.447715 27.4477 0 28 0Z",
    fill: "#363BC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4.45947C19.5523 4.45947 20 4.90719 20 5.45947L20 32C20 32.5523 19.5523 33 19 33C18.4477 33 18 32.5523 18 32L18 5.45947C18 4.90719 18.4477 4.45947 19 4.45947Z",
    fill: "#363BC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.7026C10.5523 10.7026 11 11.1504 11 11.7026L11 31.9999C11 32.5522 10.5523 32.9999 10 32.9999C9.44772 32.9999 9 32.5522 9 31.9999V11.7026C9 11.1504 9.44771 10.7026 10 10.7026Z",
    fill: "#363BC4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16.0542C1.55229 16.0542 2 16.5019 2 17.0542L2 32.0001C2 32.5524 1.55228 33.0001 1 33.0001C0.447715 33.0001 0 32.5524 0 32.0001V17.0542C0 16.5019 0.447716 16.0542 1 16.0542Z",
    fill: "#363BC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFan4High);
export default __webpack_public_path__ + "static/media/fan_4_high.675df805475b2b2539cc81af15eaf6b9.svg";
export { ForwardRef as ReactComponent };